// WARNING: KEEP EMAIL TEXTS SAME HERE AS IN TOURNIFY HEROKU SERVER
export default {
  confirmationEmailSubjectText: {
    nl: "Je inschrijving voor het toernooi is geslaagd!",
    en: "You've successfully signed up for the tournament!",
    de: "Deine Anmeldung zum Turnier war erfolgreich!",
    fr: "Votre inscription au tournoi est validée !",
    es: "¡Tu inscripción para el torneo ha sido exitosa!",
    pl: "Gratulacje, zapisałeś się na turniej!",
  },
  confirmationEmailStartText: {
    nl: "Hi, leuk dat jullie meedoen aan het toernooi. Hieronder zie je een overzicht van alle gegevens die je hebt opgestuurd.",
    en: "Hi, thanks for signing up for the tournament! You'll find an overview of the information you provided below.",
    de: "Hallo, schön, dass du am Turnier teilnimmst. Nachfolgend siehst Du eine Übersicht aller Daten, die Du gesendet hast.",
    fr: "Bonjour, merci d'avoir rejoint le tournoi. Vous trouverez ci-dessous un aperçu de toutes les données que vous avez fournies.",
    es: "Hola, qué bueno que hayáis decidido participar en el torneo.A continuación, podéis ver un resumen de todos los datos que enviasteis.",
    pl: "Cześć, dziękujemy za zapisanie się do naszego turnieju! Poniżej znajdziesz przegląd podanych przez Ciebie informacji.",
  },
  confirmationEmailEndText: {
    nl: "Wij kijken uit naar je komst! Voor vragen kan je altijd contact opnemen met de toernooicommissie.",
    en: "We can't wait to see you at our tournament! Feel free to contact the tournament organizer if you have any questions.",
    de: "Wir freuen uns auf Dich! Bei Fragen kannst Du Dich jederzeit an das Turnierkomitee wenden.",
    fr: "Nous nous réjouissons de votre visite ! Pour toute question, vous pouvez toujours contacter le comité du tournoi.",
    es: "¡Esperamos verte! Si tienes preguntas, siempre puedes contactar con la comisión del torneo.",
    pl: "Nie możemy się doczekać, aby zobaczyć Cię na naszym turnieju! Jeśli masz jakiekolwiek pytania, skontaktuj się z organizatorem.",
  },
};
